import React from "react";
import "../less/stylesheet/pageBanner.css"
let defaultStyle = {
    paddingTop: '10%',
    paddingBottom: '10%',
}

class PageBanner extends React.Component {
    constructor() {
        super()
    }

    render() {
        let {children, bgImg = '/images/contact-us-banner.jpg', bgColor = '#00af66', style = defaultStyle} = this.props;
        return (
            <section className="tab-price" id="tab-price">
                <div className={'pageBanner'}
                     style={{backgroundImage: `url(${bgImg})`, backgroundColor: `${bgColor}`, ...style}}>
                    {children}
                </div>
            </section>
        )
    }

}

export default PageBanner;
